export const CONFIG_META_INFO = [
    {
        name: 'File Info',
        path: '/no_job_id/no_output_id/metainfo',
        type: 'meta_info',
        icon:'far fa-file'
    },
];